
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
@Injectable({ providedIn: 'root' })
export class ClinicHospitalizationService extends ApiService {
  endPoint = '/api/clinicHospitalization';
  create(model, patient) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, {model, patient});
  }
}
